Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Widget954093450",
  {"root":"Widget954093450--root","wrapper":"Widget954093450--wrapper","wrapperItem":"Widget954093450--wrapperItem"},
  "",
  9,
  "Widget954093450"
);

